import { ECertificateStatus } from "./enums/certificate-status.enum";

export const ENDPOINTS = {
  MAINTENANCE: {
    STATUS: `/maintenance/status`,
  },
  AUTH: {
    LOGIN: `/auth/login/employer`,
    REGISTER_EMPLOYER: `/auth/register`,
    RESEND_REGISTRATION_OTP_TO_EMPLOYER: `/auth/register/resend-otp`,
    VERIFY_REGISTRATION_OTP: `/auth/register/verify`,
    VERIFY_LOGIN_OTP: `/auth/verify`,
    INITIATE_AUTH: "/auth",
    ADD_AUTHORIZED_CONTACT: `/auth/authorized-contact`,
    RESEND_AUTHORIZED_CONTACT_OTP: `/auth/authorized-contact/resend-otp`,
    VERIFY_AUTHORIZED_CONTACT_OTP: `/auth/authorized-contact/verify`,
    REFRESH_SESSION: `/auth/session/refresh`,
    REPORT_DISCREPANCY: `discrepancy/report`,
  },
  EMPLOYER_REGISTRATION: {
    LOOKUP_RC: `/employer-registration/lookup-rc`,
    VALIDATE_TIN: `/employer-registration/validate-tin`,
    REGISTER: `/employer-registration/register`,
    RESEND_OTP: `/employer-registration/resend-otp`,
    VERIFY_OTP: `/employer-registration/verify-otp`,
    SECTOR_CODES: `/employer-registration/sector-codes`,
    ORGANIZATION_TYPES: `/employer-registration/organization-types`,
    SECTOR_CODES_BY_ORG_TYPE: (typeCode: string) =>
      `/employer-registration/organization-types/${typeCode}/sector-codes`,
  },
  COMPLIANCE: {
    CONTRIBUTION_STATS: `/compliance/contributions/stats`,
    EMPLOYEE_STATS: `/compliance/employees/stats`,
    GET_GROUP_LIFE_INSURANCE: `/compliance/group-life-insurance`,
    ADD_GROUP_LIFE_INSURANCE: `/compliance/group-life-insurance/add`,
    UPDATE_GROUP_LIFE_INSURANCE: `/compliance/group-life-insurance/update`,
    EVALUATE_COMPLIANCE: `/compliance/evaluate`,
    SAVE_COMPLIANCE_EVALUATION: `/compliance/evaluate/save`,
    GET_COMPLIANCE_EVALUATION: `/compliance/evaluation`,
    GENERATE_CERTIFICATE: `/compliance/certificates/generate`,
    CREATE_CERTIFICATE_PAYMENT: `/compliance/payments/certificate/create`,
    CHECK_CERTIFICATE_PAYMENT: `/compliance/payments/certificate/check`,
    VERIFY_CERTIFICATE_PAYMENT: `/compliance/payments/certificate/verify`,
    PAYMENT_HISTORY: `/compliance/payments/history`,
    GET_CERTIFICATES: (status: ECertificateStatus) => {
      if (status) {
        return `/compliance/certificates?status=${status}`;
      }
      return `/compliance/certificates`;
    },
    GET_CERTIFICATE_BY_ID: (id: string) => `/compliance/certificates/${id}`,
    GET_EVALUATION_COMMENTS: (evaluationId: string) =>
      `/compliance/pcc/${evaluationId}/comment-trail`,
    RESPOND_TO_EVALUATION: `/compliance/pcc/employer/comment`,
    CONTRIBUTION_TOTAL: (employerCode: string) =>
      `/compliance/employers/${employerCode}/contribution-total`,
    EMPLOYEE_CONTRIBUTIONS: `/compliance/employee-contributions`,
    EMPLOYEE_COUNT: `/compliance/employee-contributions/employee-count`,
    CURRENT_MONTH_REPORTS: `compliance/employer-reports/current-month`,
    CURRENT_YEAR_REPORTS: `compliance/employer-reports/current-year`,
    PENALTY_STATUS: `compliance/penalties/defaulting-status`,
    PENALTIES: `compliance/penalties`,
    CONTRIBUTION_BY_MONTH: `compliance/employer-reports/contributions-by-month`,
    TASKS: `/compliance/tasks`,
    BANNERS: `/compliance/dashboard/banners`,
    PENALTIES_SCHEDULE_PDF: `/compliance/penalties/schedule-pdf`,
    PENALTIES_SCHEDULE_XLSX: `/compliance/penalties/schedule-xlsx`,
    CONTRIBUTIONS_SCHEDULE_XLSX: `/compliance/contributions/schedule-xlsx`,
    PENALTIES_BREAKDOWN: (month: string, year: string) =>
      `/compliance/penalties/breakdown?month=${encodeURIComponent(
        month
      )}&year=${encodeURIComponent(year)}`,
    SCHEDULE: `/compliance/payment-schedule`,
    ACKNOWLEDGE_DISCLAIMER: (id: string) =>
      `/compliance/certificates/${id}/acknowledge-disclaimer`,
    REFRESH_CERTIFICATE: (id: string) =>
      `/compliance/certificates/${id}/refresh`,
  },
  VERIFY_COMPLIANCE: {
    SEARCH: (q: string) => `/verify-compliance/search?q=${encodeURIComponent(q)}`,
    DETAILS: (employerCode: string) =>
      `/verify-compliance/${encodeURIComponent(employerCode)}`,
  },
  EMPLOYEES: {
    COUNT: "/employees/count",
    LIST: "/employees",
  },
  CHANGE_REQUESTS: {
    LIST: "/change-requests/list",
    CREATE: "/change-requests",
    GET_BY_ID: (id: string) => `/change-requests/${id}`,
    VALIDATE_RSA_PIN: "/change-requests/validate/rsa-pin",
  },
  EMPLOYERS: {
    TOUR_COMPLETED: "/employers/tour-completed",
  },
  FILE_UPLOAD: "/file-upload",
  FILE_UPLOAD_MULTIPLE: "/file-upload/upload-multiple",
  DOWNLOAD_CERTIFICATE: (key: string) =>
    `/file-upload/stream?key=${encodeURIComponent(key)}`,
  TUTORIALS: {
    GET_TUTORIALS: `/tutorials`,
    GET_TUTORIAL_CATEGORIES: `/tutorials/tutorial-categories`,
    GET_TUTORIAL: (id: string) => `/tutorials/${id}`,
    GET_TUTORIAL_STREAM: (id: string) => `/tutorials/${id}/stream`,
  },
  SUPPORT: {
    LIST_TICKETS: `/support/tickets`,
    GET_TICKET: (id: string) => `/support/tickets/${id}`,
    CREATE_TICKET: `/support/tickets`,
    SEND_TICKET_MESSAGE: (id: string) => `/support/tickets/${id}/messages`,
  },
  NOTIFICATIONS: {
    GET_IN_APP: (params: {
      page?: number;
      limit?: number;
      unreadOnly?: boolean;
    }) => {
      const query = new URLSearchParams();
      if (params.page) query.append("page", String(params.page));
      if (params.limit) query.append("limit", String(params.limit));
      if (params.unreadOnly) query.append("unreadOnly", "true");
      return `/notifications/in-app?${query.toString()}`;
    },
    GET_UNREAD_COUNT: `/notifications/in-app/unread-count`,
    MARK_READ: `/notifications/in-app/mark-read`,
  },
  CORRECTION_LINKS: {
    VALIDATE: (token: string) => `/correction-links/validate/${token}`,
    ADMIN_SEND: (employerCode: string) =>
      `/correction-links/admin/employers/${employerCode}/send`,
    REQUEST_CONTACT_UPDATE: "/correction-links/contact-update/request",
    SUBMIT_CONTACT_UPDATE: (token: string) =>
      `/correction-links/contact-update/${token}`,
  },
  EMPLOYER_UPDATE_REQUEST: {
    SUBMIT: "/employer-update-requests",
    SUBMIT_ONBOARDING: "/employer-update-requests/report",
    PRE_CHECK: "/employer-update-requests/pre-check",
  },
};
